import { Mapper } from "../../../../base/utils/mapper";
import { ProfileResponseModel } from "../../../../domain/models/user/profile-response.model";
import { ProfileResponseEntity } from "../entities/profile-response.entity";

export class ProfileResponseImplementationRepositoryMapper extends Mapper<ProfileResponseEntity, ProfileResponseModel> {
    mapFrom(param: ProfileResponseEntity): ProfileResponseModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: ProfileResponseModel): ProfileResponseEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}
